import { StrictMode } from "react";
import ReactDOM from "react-dom";

import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { composeWithDevTools } from "redux-devtools-extension";
import { applyMiddleware, combineReducers } from "@reduxjs/toolkit";

import { Provider } from "react-redux";
import { createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { watchAuth } from "./store/Sagas";
import { AppReducer } from "./store/Reducers";
const sagaMiddleware = createSagaMiddleware();

export const rootReducer = combineReducers({
  App: AppReducer,

});

const composeEnchancers = composeWithDevTools({
  trace: true,
  traceLimit: 25,
});

let store;

if (process.env.REACT_APP_STORE === "development") {
  store = createStore(
    rootReducer,
    composeEnchancers(applyMiddleware(sagaMiddleware))
  );
} else if (process.env.REACT_APP_STORE === "production") {
  store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
}
//missing saga listener
sagaMiddleware.run(watchAuth);
ReactDOM.render(
  <Provider store={store}>
    <StrictMode>
      <App />
    </StrictMode>
  </Provider>,
  document.getElementById("OYS")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
